module.exports = __webpack_public_path__ + "media/images/help/icon-192x192-de598feb51ac8a10f37bc1f7d12507c0.png";